export const styles = {
  imageUploader: {
    position: "relative",
    width: "800px",
  },
  imageUploaderContainer: {
    position: "relative",
    width: "100%",
  },
  label: {
    fontSize: "0.875rem",
    fontWeight: 500,
    marginBottom: "5px",
  },
};
